import styled from 'styled-components';
import { BORDER, COMMON, LAYOUT } from '../constants';
const Image = styled.img.withConfig({
  displayName: "Image",
  componentId: "sc-1allvni-0"
})(["", ";", ";", ";max-width:100%;"], BORDER, COMMON, LAYOUT);
Image.defaultProps = {
  height: 'auto',
  m: 0
};
Image.propTypes = { ...BORDER.propTypes,
  ...COMMON.propTypes,
  ...LAYOUT.propTypes
};
Image.displayName = 'Image';
export default Image;